import { createSignal } from "solid-js";

/**
 * Open state of the global quick-create modal. Module-level for the same
 * reason as commandPaletteStore: the palette's "New Work Item" quick action
 * (FLOW-801) has to open a modal owned by GlobalQuickCreate, which is mounted
 * elsewhere in the shell.
 */
const [quickCreateOpen, setQuickCreateOpen] = createSignal(false);

export { quickCreateOpen, setQuickCreateOpen };
